import React from 'react';

/**
 * Dual service CTA component specifically for coaching and speaking services
 */
const DualServiceCTA = () => {
  return (
    <section className="py-16 bg-blue-900 text-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
          Ready to Work Together?
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Coaching CTA */}
          <div className="bg-white bg-opacity-10 p-8 rounded-lg text-center">
            <h3 className="text-2xl font-bold mb-3">1-on-1 Coaching</h3>
            <p className="mb-6">
              Take your personal and professional growth to the next level with personalized coaching.
            </p>
            <a 
              href="#coaching" 
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-6 rounded-lg transition"
            >
              Apply for Coaching
            </a>
          </div>
          
          {/* Speaking CTA */}
          <div className="bg-white bg-opacity-10 p-8 rounded-lg text-center">
            <h3 className="text-2xl font-bold mb-3">Speaking Engagements</h3>
            <p className="mb-6">
              Elevate your next event with an impactful keynote presentation.
            </p>
            <a 
              href="#speaking" 
              className="inline-block bg-white hover:bg-gray-100 text-blue-900 font-bold py-3 px-6 rounded-lg transition"
            >
              Book for Your Event
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DualServiceCTA;